import { CheckCircleTwoTone } from "@ant-design/icons";
import React from "react";

const VerifiedMark: React.FC = () => (
  <CheckCircleTwoTone twoToneColor="#52c41a" title="Verified" />
);

export default VerifiedMark;
